import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppContext } from '../context/app-context';
import { FormActionDto, FormActionTypeEnum, FormApplicationTypeEnum } from '../models';
import { createForm } from '../services/forms.service';

export const createRedirectForSubmittedView = (applicationType: string | null | undefined, id: string): FormActionDto | null => {
  if (!applicationType) {
    return null;
  }
  const applicationTypeMap: Record<string, FormApplicationTypeEnum> = {
    'maintenance-priority-deviation': FormApplicationTypeEnum.MaintenancePriorityDeviation,
    'final-report-grant-simple': FormApplicationTypeEnum.FinalReportGrantSimple,
    'maintenance-amendment-of-terms': FormApplicationTypeEnum.MaintenanceAmendmentOfTerms,
  };

  const mappedApplicationType = applicationTypeMap[applicationType];
  if (!mappedApplicationType) {
    return null;
  }

  return {
    data: `/forms/submitted/${id}`,
    applicationType: mappedApplicationType,
    actionType: FormActionTypeEnum.CaseRedirect,
  } as FormActionDto;
};

export const useFormActionHandler = () => {
  const navigate = useNavigate();

  const { state } = useContext(AppContext);
  const features = state.configuration.features;

  return async (formAction: FormActionDto, replace: boolean = false) => {
    const navigationOptions: { replace?: boolean } = { replace };

    switch (formAction.actionType) {
      case FormActionTypeEnum.OpenForm:
        //TODO define better logic for opening forms of the new type...
        if (formAction.applicationType === FormApplicationTypeEnum.ReleaseOfCollaterals) {
          navigate(`/forms/releaseOfCollaterals/edit/${formAction.data}/0`, navigationOptions);
          break;
        } else if (formAction.applicationType === FormApplicationTypeEnum.MentorSupportPayout) {
          navigate(`/forms/mentorSupportPayout/edit/${formAction.data}/0`, navigationOptions);
          break;
        } else if (formAction.applicationType === FormApplicationTypeEnum.MaintenancePriorityDeviation) {
          navigate(`/forms/maintenancePriorityDeviation/edit/${formAction.data}/0`, navigationOptions);
          break;
        } else if (formAction.applicationType === FormApplicationTypeEnum.MaintenanceAmendmentOfTerms) {
          navigate(`/forms/maintenanceAmendmentOfTermsApplication/edit/${formAction.data}/0`, { replace: replace });
          break;
        } else if (formAction.applicationType === FormApplicationTypeEnum.FinalReportGrantSimple) {
          navigate(`/forms/finalReportGrantSimple/edit/${formAction.data}/0`, navigationOptions);
          break;
        }

        if (formAction.applicationType === FormApplicationTypeEnum.PayoutRequestGrantSimple) {
          navigate(`/forms/payoutRequestGrantSimple/edit/${formAction.data}/0`, navigationOptions);
          break;
        }

        if (formAction.applicationType === FormApplicationTypeEnum.DeMinimisAidV2) {
          navigate(`/forms/deMinimisAid/edit/${formAction.data}/0`, navigationOptions);
          break;
        }

        if (formAction.applicationType === FormApplicationTypeEnum.DeMinimisAid) {
          const feature = features?.find((f) => f.name === 'DeMinimisAidV2');

          if (feature?.isActive) {
            navigate(`/forms/deMinimisAid/edit/${formAction.data}/0`, navigationOptions);
            break;
          }
        }

        navigate(`/forms/edit/${formAction.data}/0`, navigationOptions);
        break;
      case FormActionTypeEnum.CreateForm: {
        const formId = await createForm(formAction.applicationType, formAction.data);

        //TODO define better logic for opening forms of the new type...
        if (formAction.applicationType === FormApplicationTypeEnum.ReleaseOfCollaterals) {
          navigate(`/forms/releaseOfCollaterals/edit/${formId}/0`, navigationOptions);
          break;
        } else if (formAction.applicationType === FormApplicationTypeEnum.MentorSupportPayout) {
          navigate(`/forms/mentorSupportPayout/edit/${formId}/0`, navigationOptions);
          break;
        } else if (formAction.applicationType === FormApplicationTypeEnum.MaintenancePriorityDeviation) {
          navigate(`/forms/maintenancePriorityDeviation/edit/${formId}/0`, navigationOptions);
          break;
        } else if (formAction.applicationType === FormApplicationTypeEnum.MaintenanceAmendmentOfTerms) {
          navigate(`/forms/maintenanceAmendmentOfTermsApplication/edit/${formId}/0`, { replace: replace });
          break;
        } else if (formAction.applicationType === FormApplicationTypeEnum.FinalReportGrantSimple) {
          navigate(`/forms/finalReportGrantSimple/edit/${formId}/0`, navigationOptions);
          break;
        }

        if (formAction.applicationType === FormApplicationTypeEnum.PayoutRequestGrantSimple) {
          navigate(`/forms/payoutRequestGrantSimple/edit/${formId}/0`, navigationOptions);
          break;
        }

        if (formAction.applicationType === FormApplicationTypeEnum.DeMinimisAidV2) {
          navigate(`/forms/deMinimisAid/edit/${formId}/0`, navigationOptions);
          break;
        }

        if (formAction.applicationType === FormApplicationTypeEnum.DeMinimisAid) {
          const feature = features?.find((f) => f.name === 'DeMinimisAidV2');

          if (feature?.isActive) {
            navigate(`/forms/deMinimisAid/edit/${formId}/0`, navigationOptions);
            break;
          }
        }

        navigate(`/forms/edit/${formId}/0`, navigationOptions);
        break;
      }
      case FormActionTypeEnum.ShowSubmitted:
        navigate(`/forms/submitted/${formAction.data}`, navigationOptions);
        break;
      case FormActionTypeEnum.OpusRedirect:
        window.open(formAction.data as string, '_blank');
        break;
      case FormActionTypeEnum.CaseRedirect:
        window.location.replace(formAction.data as string);
        break;
    }
  };
};
